import { toLocationGroupAddressInput } from './address-form-rules.js';
export function toCreateLocationGroupInput(values) {
    return {
        name: values.name.trim(),
        activeFlag: values.activeFlag,
        address: toLocationGroupAddressInput(values),
        locations: values.locations.map((location) => ({
            name: location.name.trim(),
            description: location.description.trim() || undefined,
            typeId: Number(location.typeId),
            activeFlag: location.activeFlag,
            pickable: location.pickable,
            receivable: location.receivable,
            countedAsAvailable: location.countedAsAvailable,
        })),
    };
}
//# sourceMappingURL=to-create-location-group-input.js.map